/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespFollowSearchTopButton_user = {
    readonly serviceId: string | null;
    readonly favorites: {
        readonly " $fragmentRefs": FragmentRefs<"FollowSearchButton_favoritesConnection">;
    } | null;
    readonly " $refType": "SbRespFollowSearchTopButton_user";
};
export type SbRespFollowSearchTopButton_user$data = SbRespFollowSearchTopButton_user;
export type SbRespFollowSearchTopButton_user$key = {
    readonly " $data"?: SbRespFollowSearchTopButton_user$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespFollowSearchTopButton_user">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbRespFollowSearchTopButton_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "followSearchTypes",
      "type": "[types]"
    },
    {
      "kind": "RootArgument",
      "name": "followSearchPages",
      "type": "[String]"
    }
  ],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "favorites",
      "storageKey": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 1
        },
        {
          "kind": "Variable",
          "name": "pages",
          "variableName": "followSearchPages"
        },
        {
          "kind": "Variable",
          "name": "types",
          "variableName": "followSearchTypes"
        }
      ],
      "concreteType": "favoritesConnection",
      "plural": false,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "FollowSearchButton_favoritesConnection",
          "args": null
        }
      ]
    }
  ]
};
(node as any).hash = 'a3c6a58e43da1f5d7cdfe1744df9c8d1';
export default node;
